module.exports = __webpack_public_path__ + "img/ida.69a0d010.webp";